/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown> }} Wrapped_Period_Volume_PillInputs */

const en_us2_wrapped_period_volume_pill = /** @type {(inputs: Wrapped_Period_Volume_PillInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Volume · ${i?.range}`)
};

const pt_br2_wrapped_period_volume_pill = /** @type {(inputs: Wrapped_Period_Volume_PillInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Volume · ${i?.range}`)
};

const es_419_wrapped_period_volume_pill = /** @type {(inputs: Wrapped_Period_Volume_PillInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Volumen · ${i?.range}`)
};

const pt_pt2_wrapped_period_volume_pill = /** @type {(inputs: Wrapped_Period_Volume_PillInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Volume · ${i?.range}`)
};

const fr_fr2_wrapped_period_volume_pill = /** @type {(inputs: Wrapped_Period_Volume_PillInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Volume · ${i?.range}`)
};

const de_de2_wrapped_period_volume_pill = /** @type {(inputs: Wrapped_Period_Volume_PillInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Volumen · ${i?.range}`)
};

const it_it2_wrapped_period_volume_pill = /** @type {(inputs: Wrapped_Period_Volume_PillInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Volume · ${i?.range}`)
};

/**
* | output |
* | --- |
* | "Volume · {range}" |
*
* @param {Wrapped_Period_Volume_PillInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_volume_pill = /** @type {((inputs: Wrapped_Period_Volume_PillInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Volume_PillInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_volume_pill(inputs)
	if (locale === "es-419") return es_419_wrapped_period_volume_pill(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_volume_pill(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_volume_pill(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_volume_pill(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_volume_pill(inputs)
	return en_us2_wrapped_period_volume_pill(inputs)
});
export { wrapped_period_volume_pill as "wrapped-period.volume_pill" }